import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./index.css";
import AnimatedCounter from "../Shared/AnimatedCounter.js";
import commercial from "../assests/animals/commercialized.svg";
import countries from "../assests/animals/countriespresence.svg";
import USFDAS from "../assests/animals/box.svg";
import minImage from "../assests/animals/images.svg"
import greenCheck from "../assests/animals/tick.png"
import marketStrategy from "../assests/animals/marketStrategy.svg";
import AHSites from "../assests/animals/industry.svg";
import totalSites from "../assests/animals/growth.svg";
import facilityIcon from "../assests/animals/Facility.svg";
import keyCapabilities from "../assests/animals/keycapabilities.svg";
import checklistIcon from "../assests/animals/checklist.svg";
import locationIcon from "../assests/animals/location.svg";
import cattleImg from "../assests/animals/cattle.png";
import poultryImg from "../assests/animals/poultry.png";
import moleculesIcon from "../assests/animals/molecules.svg";
import minPaw from "../assests/animals/minPaw.svg";
import animalPhd from "../assests/animals/animalPhd.svg";
import animalRD from "../assests/animals/animalR&D.svg";
import animalScientist from "../assests/animals/animalScientist.svg";
import heroBg from "../assests/animals/animalSection.png";
import newWorldMap from "../assests/animals/newWorld.png";
import worldLogo from "../assests/animals/world-log.svg";
import future1 from "../assests/animals/future-1.svg";
import future2 from "../assests/animals/future-2.svg";
import future3 from "../assests/animals/future-3.svg";
import future4 from "../assests/animals/future-4.svg";
import manufacture from "../assests/animals/AH-sites.svg"
import manufacture2 from "../assests/animals/total_sites.svg"
import manufacture3 from "../assests/animals/USFDA_approved.svg"

export function useScrollAnimation() {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const element = ref.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.unobserve(element);
                }
            },
            { threshold: 0.1 }
        );

        if (element) observer.observe(element);
        return () => observer.disconnect();
    }, []);

    return [ref, visible];
}

const HomeIcon = () => (
    <svg className="animal-health-breadcrumb-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M10 14V8.66667C10 8.48986 9.92976 8.32029 9.80474 8.19526C9.67971 8.07024 9.51014 8 9.33333 8H6.66667C6.48986 8 6.32029 8.07024 6.19526 8.19526C6.07024 8.32029 6 8.48986 6 8.66667V14" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 6.66667C1.99995 6.47271 2.04222 6.28108 2.12386 6.10514C2.20549 5.92921 2.32453 5.7732 2.47267 5.648L7.13933 1.64867C7.37999 1.44527 7.6849 1.33368 8 1.33368C8.3151 1.33368 8.62001 1.44527 8.86067 1.64867L13.5273 5.648C13.6755 5.7732 13.7945 5.92921 13.8761 6.10514C13.9578 6.28108 14 6.47271 14 6.66667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V6.66667Z" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const stats = [
    {
        icon: commercial,
        value: "1000+",
        title: "Finished Drug formulations",
    },
    {
        icon: countries,
        value: "100+",
        title: "Countries Presence"
    },
    {
        icon: AHSites,
        value: "5",
        title: "Manufacturing Sites"
    },
    // {
    //     icon: USFDAS,
    //     value: "100+",
    //     title: "USFDA Approved sites"
    // },
    {
        icon: totalSites,
        value: "25+",
        title: "R&D pipelines"
    }
]
const products = [
    { name: "Fluoxetine", type: "Companion / CNS", companion: true },
    { name: "Ciclosporin", type: "Companion / Immuno", companion: true },
    { name: "Meloxicam", type: "NSAID", companion: false },
    { name: "Tramadol", type: "Analgesic", companion: false },
    { name: "Terbinafine", type: "Antifungal", companion: false },
    { name: "Gabapentin", type: "Companion / CNS", companion: true },
    { name: "Metronidazole", type: "Anti-Bacterial", companion: false },
    { name: "Doramectin", type: "Anthelmintic", companion: false },
    { name: "Moxidectin", type: "Anti-Parasitic", companion: false },
    { name: "Cefpodoxime", type: "Anti-Bacterial", companion: false },
    { name: "Propentofylline", type: "Companion / CNS", companion: true },
    { name: "Trazodone", type: "Companion / CNS", companion: true }
];
const AnimalHealth = () => {
    const [ref1, visible1] = useScrollAnimation();
    const [ref2, visible2] = useScrollAnimation();
    const [ref3, visible3] = useScrollAnimation();
    const [ref4, visible4] = useScrollAnimation();
    const [ref5, visible5] = useScrollAnimation();
    const [ref6, visible6] = useScrollAnimation();
    const [ref7, visible7] = useScrollAnimation();

    return (
        <div className="animal-health-page">

            <section className="animal-health-hero-section" style={{ backgroundImage: `url(${heroBg})` }}>

                <div className="animal-health-hero-overlay"></div>
                <div className="animal-health-hero-content">
                    <h1 className="animal-health-hero-title">ANIMAL HEALTH</h1>
                    <h2 className="animal-health-hero-subtitle">Formulations Platform Serving Global Veterinary Markets</h2>
                    <p className="animal-health-hero-description">
                        Viyash Scientific is a fully backward-integrated pharmaceutical enterprise with a strong presence in animal health formulations and a diversified portfolio built on long-term partnerships with industry leaders.
                    </p>
                </div>
            </section>

            <div className="animal-health-breadcrumb-container">
                <div className="animal-health-breadcrumb-wrapper">
                    <div className="animal-health-breadcrumb-links">
                        <Link
                            to="/"
                            className="animal-health-breadcrumb-link animal-health-home-link"
                        >
                            <HomeIcon /> Home
                        </Link>
                        <span className="animal-health-breadcrumb-separator" style={{ padding: "10px" }}>›</span>
                        <span className="animal-health-breadcrumb-current">Animal Health</span>
                    </div>
                </div>
            </div>
            <section ref={ref4} className={`vet-section reveal reveal-up ${visible4 ? "reveal-visible" : ""}`}>
                <div className="wrapper">

                    <h2 className="vet-title">Vet Formulation</h2>

                    <div className="vet-divider">
                        <span className="vet-line left"></span>
                        <div className="vet-logo">
                            <img src={minImage} alt="logo" />
                        </div>
                        <span className="vet-line right"></span>
                    </div>

                    {/* CARD GRID */}
                    <div className="vet-grid">

                        {/* CARD 1: Cattle */}
                        <div className={`vet-card reveal reveal-left ${visible4 ? "reveal-visible" : ""}`} style={{ transitionDelay: '0.1s' }}>
                            <img src={cattleImg} alt="Cattle" />

                            <div className="vet-card-body">
                                <h3>Cattle</h3>

                                <p>
                                    Committed to continuous improvement by understanding customer
                                    needs and expectations, while delivering innovative solutions
                                    and services.
                                </p>

                                <a href="https://alivira.co.in/category/cattle/" className="vet-btn" target="_blank" rel="noopener noreferrer">LEARN MORE</a>
                            </div>
                        </div>

                        {/* CARD 2: Poultry */}
                        <div className={`vet-card reveal reveal-right ${visible4 ? "reveal-visible" : ""}`} style={{ transitionDelay: '0.2s' }}>
                            <img src={poultryImg} alt="Poultry" />

                            <div className="vet-card-body">
                                <h3>Poultry</h3>

                                <p>
                                    Partnering with farmers and feed mill owners to support feed
                                    cost optimization, improved animal health, and enhanced
                                    productivity through an R&D-driven product portfolio and
                                    technical expertise.
                                </p>

                                <a href="https://alivira.co.in/category/poultry/" className="vet-btn" target="_blank" rel="noopener noreferrer">LEARN MORE</a>
                            </div>
                        </div>




                    </div>
                </div>
                {/* TITLE */}


            </section>
            <div ref={ref1} className={`stats-section reveal reveal-up ${visible1 ? "reveal-visible" : ""}`}>
                <div className="wrapper">
                    <div className="stats-container ">

                        {stats.map((item, index) => (
                            <div className={`stat-card reveal reveal-up ${visible1 ? "reveal-visible" : ""}`} key={index} style={{ transitionDelay: `${index * 0.1}s` }}>
                                <div className="stat-card-top">
                                    <div className="stat-icon">
                                        <img src={item.icon} alt={item.value} />
                                    </div>
                                    <h3 className="stat-value"><AnimatedCounter value={item.value} /></h3>
                                </div>
                                <h4 className="stat-title">{item.title}</h4>
                            </div>
                        ))}

                    </div>
                </div>
            </div>



            <section ref={ref2} className={`market-section reveal reveal-up ${visible2 ? "reveal-visible" : ""}`}>

                <div className="wrapper">
                    <h2 className="market-title">Global Market Presence</h2>

                    {/* Divider */}
                    <div className="market-divider">
                        <span className="line left"></span>
                        <div className="logo-circle">
                            <img src={minImage} alt="logo" />
                        </div>
                        <span className="line right"></span>
                    </div>

                    {/* Subtitle */}
                    <p className="market-subtitle">
                        Present in 100+ countries with own front-end operations and long-term
                        innovator partnerships.
                    </p>

                    {/* Main Grid */}
                    <div className="market-grid">

                        {/* LEFT SIDE - MAP */}

                        <div className="market-map-container" style={{ backgroundImage: `url(${newWorldMap})` }}>
                            <div className="market-map-tag">
                                <img src={worldLogo} alt="world" className="market-map-icon" />
                                <span>Veterinary Market Presence</span>
                            </div>
                        </div>


                        {/* RIGHT SIDE */}
                        <div className="market-right">

                            {/* Market Strategy */}
                            <div className={`strategy-card reveal reveal-right ${visible2 ? "reveal-visible" : ""}`}>
                                <div className="card-title">
                                    <img src={marketStrategy} alt="location" className="title-icon" />
                                    Market Strategy
                                </div>

                                <ul className="strategy-list">
                                    <li>
                                        <img src={greenCheck} alt="check" className="check-icon" />
                                        <span>Long-term relationships with global innovator companies</span>
                                    </li>
                                    <li>
                                        <img src={greenCheck} alt="check" className="check-icon" />
                                        <span>Strong positions in Spain, Turkey, Brazil, Benelux and India</span>
                                    </li>
                                    <li>
                                        <img src={greenCheck} alt="check" className="check-icon" />
                                        <span>Global expansion through acquisitions in Spain, Brazil, Turkey Belgium and Sweden</span>
                                    </li>
                                    <li>
                                        <img src={greenCheck} alt="check" className="check-icon" />
                                        <span>Own front-end presence in 9 core markets with ~300-strong field force</span>
                                    </li>
                                    <li>
                                        <img src={greenCheck} alt="check" className="check-icon" />
                                        <span>Dedicated Companion Animal focus across EU, LATAM and Asia</span>
                                    </li>
                                </ul>
                            </div>

                            {/* Regional Breakdown */}
                            <div className={`regional-card reveal reveal-right ${visible2 ? "reveal-visible" : ""}`}>
                                <h4 className="regional-title">Regional Breakdown</h4>
                                <div className="region-row europe">
                                    <span className="region-bullet"></span>
                                    <span className="region-name">Europe</span>
                                    <small>Spain, Benelux</small>
                                </div>
                                <div className="region-row americas">
                                    <span className="region-bullet"></span>
                                    <span className="region-name">America</span>
                                    <small>Brazil, USA</small>
                                </div>
                                <div className="region-row asia">
                                    <span className="region-bullet"></span>
                                    <span className="region-name">Asia Pacific</span>
                                    <small>India, Australia</small>
                                </div>
                                <div className="region-row mea">
                                    <span className="region-bullet"></span>
                                    <span className="region-name">Middle East & Africa</span>
                                    <small>South Africa, GCC</small>
                                </div>
                                <div className="region-row row">
                                    <span className="region-bullet"></span>
                                    <span className="region-name">Rest of World</span>
                                    <small>Japan (PMDA), Korea (KDMF)</small>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
                {/* Title */}


            </section>
            <section ref={ref3} className={`mf-section reveal reveal-up ${visible3 ? "reveal-visible" : ""}`}>

                {/* TITLE */}
                <h2 className="mf-title">Manufacturing Footprint</h2>

                <div className="mf-divider">
                    <span className="mf-line left"></span>
                    <div className="mf-icon">
                        <img src={minImage} alt="logo" style={{ width: '100%', height: '100%' }} />
                    </div>
                    <span className="mf-line right"></span>
                </div>

                <p className="mf-subtitle">
                    With a strengthened network of integrated facilities, Viyash ensures supply
                    security, regulatory compliance, and scalable production for veterinary
                    markets globally.
                </p>

                {/* STATS */}
                {/* <div className="mf-stats">

                    <div className={`mf-stat-card reveal reveal-up ${visible3 ? "reveal-visible" : ""}`} style={{ transitionDelay: '0.1s' }}>
                        <div className="mf-stat-icon green">
                            <img src={manufacture} alt="AH Sites" />
                        </div>
                        <div style={{ textAlign: "left" }}>
                            <h3 className="green-text" style={{ fontSize: "33.6px" }}><AnimatedCounter value="4" /></h3>
                            <p style={{ fontSize: "14px", color: "#1E2939", fontWeight: "600" }}>FDF / AH Sites</p>
                        </div>
                    </div>

                    <div className={`mf-stat-card reveal reveal-up ${visible3 ? "reveal-visible" : ""}`} style={{ transitionDelay: '0.2s' }}>
                        <div className="mf-stat-icon purple">
                            <img src={manufacture2} alt="Total Sites" />
                        </div>
                        <div style={{ textAlign: "left" }}>
                            <h3 className="purple-text" style={{ fontSize: "33.6px" }}><AnimatedCounter value="15" /></h3>
                            <p style={{ fontSize: "14px", color: "#1E2939", fontWeight: "600" }}>Total Sites (Merged Entity)</p>
                        </div>
                    </div>

                    <div className={`mf-stat-card reveal reveal-up ${visible3 ? "reveal-visible" : ""}`} style={{ transitionDelay: '0.3s' }}>
                        <div className="mf-stat-icon red">
                            <img src={manufacture3} alt="USFDA Approved" />
                        </div>
                        <div style={{ textAlign: "left" }}>
                            <h3 className="red-text" style={{ fontSize: "33.6px" }}><AnimatedCounter value="100%" /></h3>
                            <p style={{ fontSize: "14px", color: "#1E2939", fontWeight: "600" }}>USFDA Approved Network</p>
                        </div>
                    </div>

                </div> */}
                <div className={`mf-card reveal reveal-left ${visible3 ? "reveal-visible" : ""}`} style={{ width: '100%', maxWidth: '1280px', margin: '0 auto' }}>

                    <div className="mf-card-header">
                        <img src={facilityIcon} alt="Facility" style={{ width: '18px', height: '18px' }} /> Facility Summary
                    </div>

                    <div className="mf-table-container">
                        <table className="mf-table">
                            <thead>
                                <tr>
                                    <th style={{ paddingLeft: "20px", width: "35%" }}>UNIT</th>
                                    <th style={{ width: "23%" }}>LOCATION</th>
                                    {/* <th style={{ width: "24%" }}>TYPE</th> */}
                                    <th style={{ width: "18%", paddingLeft: "20px" }}>CERTS</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td style={{ color: '#1E2939', fontSize: "13px", padding: "16px 20px", fontWeight: "500" }}>Barcelona</td>
                                    <td style={{ color: "#6A7282", fontSize: "13px" }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <img src={locationIcon} alt="location" style={{ width: '24px', height: '24px' }} />
                                            <span>Spain</span>
                                        </div>
                                    </td>
                                    {/* <td style={{ color: "#4A5565", fontSize: "13px" }}>Animal Health – EU</td> */}
                                    <td className="mf-certs-cell"><span className="tag" style={{ padding: "0px 6px", fontSize: "12px", background: "#EDFAF3", color: "#16a34a", borderColor: "#EDFAF3", fontWeight: "600" }}>EUGMP</span></td>
                                </tr>

                                <tr>
                                    <td style={{ color: '#1E2939', fontSize: "13px", padding: "16px 20px", fontWeight: "500" }}>Campinas & Minal Gerais</td>
                                    <td style={{ color: "#6A7282", fontSize: "13px" }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <img src={locationIcon} alt="location" style={{ width: '24px', height: '24px' }} />
                                            <span>Brazil</span>
                                        </div>
                                    </td>
                                    {/* <td style={{ color: "#4A5565", fontSize: "13px" }}>Animal Health – EU</td> */}
                                    <td className="mf-certs-cell" ><span className="tag" style={{ padding: "0px 6px", fontSize: "12px", background: "#EDFAF3", color: "#16a34a", borderColor: "#EDFAF3", fontWeight: "600" }}>MAPA</span></td>
                                </tr>

                                <tr>
                                    <td style={{ color: '#1E2939', fontSize: "13px", padding: "16px 20px", fontWeight: "500" }}>Ankara</td>
                                    <td style={{ color: "#6A7282", fontSize: "13px" }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <img src={locationIcon} alt="location" style={{ width: '24px', height: '24px' }} />
                                            <span>Turkey</span>
                                        </div>
                                    </td>
                                    {/* <td style={{ color: "#4A5565", fontSize: "13px" }}>Animal Health – EU</td> */}
                                    <td className="mf-certs-cell">
                                        <span className="tag" style={{ padding: "0px 6px", fontSize: "12px", background: "#EDFAF3", color: "#16a34a", borderColor: "#EDFAF3", fontWeight: "600" }}>EUGMP</span>

                                    </td>
                                </tr>

                                <tr>
                                    <td style={{ color: '#1E2939', fontSize: "13px", padding: "16px 20px", fontWeight: "500" }}>Ambernath</td>
                                    <td style={{ color: "#6A7282", fontSize: "13px" }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <img src={locationIcon} alt="location" style={{ width: '24px', height: '24px' }} />
                                            <span>India</span>
                                        </div>
                                    </td>
                                    {/* <td style={{ color: "#4A5565", fontSize: "13px" }}>Animal Health – EU</td> */}
                                    <td className="mf-certs-cell"><span className="tag" style={{ padding: "0px 6px", fontSize: "12px", background: "#EDFAF3", color: "#16a34a", borderColor: "#EDFAF3", fontWeight: "600" }}>cGMP</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
                {/* MAIN GRID */}
                <div className="mf-grid">

                    {/* FACILITY TABLE */}


                    {/* KEY CAPABILITIES */}
                    {/* <div className={`mf-card-key reveal reveal-right ${visible3 ? "reveal-visible" : ""}`}>

                        <div className="card-title">
                            <img src={keyCapabilities} alt="keyCapabilities" className="title-icon" />
                            Key Capabilities
                        </div>


                        <ul className="mf-list">
                            <li><img src={checklistIcon} alt="check" className="mf-check-icon" /> Capacity: 1 kg – 1,000 kg batch flexibility</li>
                            <li><img src={checklistIcon} alt="check" className="mf-check-icon" /> Fully backward integrated – 85% API self-sufficiency</li>
                            <li><img src={checklistIcon} alt="check" className="mf-check-icon" /> ISO Class 8 cleanrooms with isolator technology</li>
                            <li><img src={checklistIcon} alt="check" className="mf-check-icon" /> Prep HPLC capability for complex purification</li>
                            <li><img src={checklistIcon} alt="check" className="mf-check-icon" /> Dedicated Animal Health API suites</li>
                            <li><img src={checklistIcon} alt="check" className="mf-check-icon" /> Sterile injectable manufacturing capability</li>
                        </ul>

                    </div> */}

                </div>

            </section>

            {/* <section ref={ref5} className={`pta-section reveal reveal-up ${visible5 ? "reveal-visible" : ""}`}>

                <h2 className="pta-title">Products & Therapeutic Areas</h2>

                <div className="pta-divider">
                    <span className="pta-line left"></span>
                    <div className="pta-logo">
                        <img src={minImage} alt="logo" />
                    </div>
                    <span className="pta-line right"></span>
                </div>

                <p className="pta-subtitle">
                    48 commercial APIs · 70% new pipeline focused on Companion Animals
                </p>

                
                <div className={`pta-banner reveal reveal-up ${visible5 ? "reveal-visible" : ""}`}>
                    <div className="pta-banner-header">
                        <img src={moleculesIcon} alt="flask" />
                        <h4>12 molecules under active development</h4>
                    </div>
                    <p>
                        70% of our new Animal Health pipeline is focused on Companion Animals,
                        addressing growing demand for pet therapeutics in key regulated markets.
                    </p>
                </div>

               
                <div className="pta-grid">
                    {products.map((item, index) => (
                        <div className={`pta-card reveal reveal-up ${visible5 ? "reveal-visible" : ""}`} key={index} style={{ transitionDelay: `${(index % 4) * 0.1}s` }}>

                            <div className="pta-card-header">
                                <div className="pta-icon">
                                    <img src={moleculesIcon} alt="flask" />
                                </div>
                                {item.companion && <span className="pta-badge">Companion</span>}
                            </div>

                            <h4>{item.name}</h4>
                            <div className="pta-type">
                                <img src={minPaw} alt="paw" className="paw-icon" />
                                <p>{item.type}</p>
                            </div>

                        </div>
                    ))}
                </div>

            </section> */}
            {/* <section ref={ref6} className={`rd-section reveal reveal-up ${visible6 ? "reveal-visible" : ""}`}>

               
                <h2 className="rd-title">Research & Development</h2>

                <div className="rd-divider">
                    <span className="rd-line left"></span>
                    <div className="rd-logo">
                        <img src={minImage} alt="logo" />
                    </div>
                    <span className="rd-line right"></span>
                </div>

                <p className="rd-subtitle">
                    Proven capability to handle complex veterinary molecules with scalable,
                    first-shot OK development.
                </p>

               
                <div className="rd-stats">

                    <div className={`rd-stat-card reveal reveal-up ${visible6 ? "reveal-visible" : ""}`} style={{ transitionDelay: '0.1s' }}>
                        <div className="rd-icon blue">
                            <img src={animalRD} alt="Scientist" />
                        </div>
                        <h3><AnimatedCounter value="200+" /></h3>
                        <p>R&D Workforce</p>
                    </div>

                    <div className={`rd-stat-card reveal reveal-up ${visible6 ? "reveal-visible" : ""}`} style={{ transitionDelay: '0.2s' }}>
                        <div className="rd-icon green">
                            <img src={animalScientist} alt="R&D" />
                        </div>
                        <h3 className="green-text " style={{ color: "#00A651" }}><AnimatedCounter value="200+" /></h3>
                        <p>Scientists</p>
                    </div>

                    <div className={`rd-stat-card reveal reveal-up ${visible6 ? "reveal-visible" : ""}`} style={{ transitionDelay: '0.3s' }}>
                        <div className="rd-icon purple">
                            <img src={animalPhd} alt="PhDs" />
                        </div>
                        <h3 className="purple-text" style={{ color: "#7C3AED" }}><AnimatedCounter value="20+" /></h3>
                        <p>PhDs</p>
                    </div>

                </div>

               
                <div className={`rd-banner reveal reveal-up ${visible6 ? "reveal-visible" : ""}`}>

                    <div className="rd-banner-content">
                        <h3>World-class R&D Infrastructure</h3>
                        <p>Supporting API innovation for veterinary markets globally</p>
                    </div>

                    <div className="rd-banner-stats">
                        <div>
                            <h3><AnimatedCounter value="190+" /></h3>
                            <p>Scientists</p>
                        </div>

                        <div>
                            <h3><AnimatedCounter value="55+" /></h3>
                            <p>Patents Filed</p>
                        </div>
                    </div>

                </div>

               
                <p className="rd-description" >
                    We are dedicated to delivering exceptional products, backed by our
                    best-in-class six global R&D centres located in Ambernath, Barcelona,
                    Campinas, Turkey. These centres work tirelessly to meet the rigorous
                    standards of the US, EU, and other regulated markets, while our Campinas
                    satellite centre customizes developments to meet local needs.
                </p>

            </section>
            <section ref={ref7} className={`vet-hero reveal reveal-up ${visible7 ? "reveal-visible" : ""}`}>

              
                <div className="vet-info-cards">
                    <div className={`vet-info-card reveal reveal-up ${visible7 ? "reveal-visible" : ""}`} style={{ transitionDelay: '0.1s' }}>
                        <div className="vet-icon-box">
                            <img src={future1} alt="Integrated Manufacturing" />
                        </div>
                        <div>
                            <h4>Integrated Manufacturing</h4>
                            <p>16 sites · 10 USFDA approved</p>
                        </div>
                    </div>

                    <div className={`vet-info-card reveal reveal-up ${visible7 ? "reveal-visible" : ""}`} style={{ transitionDelay: '0.2s' }}>
                        <div className="vet-icon-box">
                            <img src={future2} alt="Regulatory Expertise" />
                        </div>
                        <div>
                            <h4>Regulatory Expertise</h4>
                            <p>48 USDMFs · 190+ patents filed</p>
                        </div>
                    </div>

                    <div className={`vet-info-card reveal reveal-up ${visible7 ? "reveal-visible" : ""}`} style={{ transitionDelay: '0.3s' }}>
                        <div className="vet-icon-box">
                            <img src={future3} alt="Science-Driven Pipeline" />
                        </div>
                        <div>
                            <h4>Science-Driven Pipeline</h4>
                            <p>70% focused on Companion Animals</p>
                        </div>
                    </div>

                    <div className={`vet-info-card reveal reveal-up ${visible7 ? "reveal-visible" : ""}`} style={{ transitionDelay: '0.4s' }}>
                        <div className="vet-icon-box">
                            <img src={future4} alt="Global Reach" />
                        </div>
                        <div>
                            <h4>Global Reach</h4>
                            <p>100+ countries · 250+ customers</p>
                        </div>
                    </div>
                </div>

               
                <div className="vet-content">

                    <h1>
                        Partnering for a Healthier <br />
                        <span>Veterinary Future</span>
                    </h1>

                    <p className="vet-description">
                        With integrated manufacturing, regulatory expertise, and a science-driven pipeline,
                        Viyash Scientific’s Animal Health division is positioned as a global growth partner —
                        delivering quality veterinary APIs and formulations to markets across 100+ countries.
                    </p>

                    <button className="vet-cta-btn">
                        Contact Animal Health Team →
                    </button>

                </div>

            </section> */}
        </div>
    );
};

export default AnimalHealth;
